import React from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import RequestsPage from "@/pages/RequestsPage";
import PayslipsTab from "@/components/hr/PayslipsTab";
import HolidaysTab from "@/components/hr/HolidaysTab";
import AnnouncementsTab from "@/components/hr/AnnouncementsTab";
import EmployeesTab from "@/components/hr/EmployeesTab";
import PayrollTab from "@/components/hr/PayrollTab";
import { MyProfileTab, HrSettingsTab } from "@/components/hr/HrBits";

export default function HrPage() {
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const isHr = user.is_hr || user.is_owner;
  const salaryAdmin = !!user.is_hr && ["manager", "admin"].includes(user.role);
  const tabs = [
    ["requests", "Leave & Reimbursements"], ["payslips", "My payslips"], ["holidays", "Holidays"],
    ["announcements", "Announcements"], ["profile", "My profile"],
    ...(isHr ? [["employees", "Employees"]] : []), ...(salaryAdmin ? [["payroll", "Payroll"]] : []), ...(isHr ? [["settings", "HR settings"]] : []),
  ];
  const tab = tabs.some(([k]) => k === params.get("tab")) ? params.get("tab") : "requests";

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-[1200px]" data-testid="hr-page">
      <h1 className="font-display text-3xl font-extrabold tracking-tight text-slate-900">HR</h1>
      <p className="text-sm text-slate-500 mt-1 mb-5">Leave, reimbursements, payslips, holidays and company updates.</p>
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v }, { replace: true })}>
        <div className="overflow-x-auto scroll-thin -mx-1 px-1 mb-5">
          <TabsList className="w-max">{tabs.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`hr-tab-${k}`}>{l}</TabsTrigger>)}</TabsList>
        </div>
        <TabsContent value="requests"><RequestsPage embedded /></TabsContent>
        <TabsContent value="payslips"><PayslipsTab /></TabsContent>
        <TabsContent value="holidays"><HolidaysTab canManage={isHr} /></TabsContent>
        <TabsContent value="announcements"><AnnouncementsTab canManage={isHr} /></TabsContent>
        <TabsContent value="profile"><MyProfileTab /></TabsContent>
        {isHr && <TabsContent value="employees"><EmployeesTab salaryAdmin={salaryAdmin} /></TabsContent>}
        {salaryAdmin && <TabsContent value="payroll"><PayrollTab /></TabsContent>}
        {isHr && <TabsContent value="settings"><HrSettingsTab /></TabsContent>}
      </Tabs>
    </div>
  );
}
